import reducer from './reducers';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';

export default {
  actions,
  reducer,
  actionTypes,
  selectors,
};
